// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"977784a2","239":"a8e2025f","455":"2f0f2a82"}[chunkId] + ".chunk.js";
};